export enum RenewalStrategy {
  RESET = "RESET",
  CARRY_OVER = "CARRY_OVER",
  EXPIRE = "EXPIRE",
}
